import { Button, Card, CardContent, CardHeader, CardTitle, Input, Label, Textarea } from "@repo/ui";

export default function Contact() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12 space-y-8">
      <header className="space-y-2">
        <h1 className="text-4xl font-bold" style={{ fontFamily: "var(--font-display)" }}>
          Contact Us
        </h1>
        <p className="text-muted-foreground">
          We’re happy to help with orders, classes, and custom requests.
        </p>
      </header>

      <Card>
        <CardHeader>
          <CardTitle>Details</CardTitle>
        </CardHeader>
        <CardContent className="grid gap-3 text-sm">
          <p>
            <span className="font-medium">Phone:</span> 094-0794-0794
          </p>
          <p>
            <span className="font-medium">Opening hours:</span> Daily, 09:00 – 22:00
          </p>
          <p>
            <span className="font-medium">Location:</span> Velaa Sindhorn Village, Bangkok
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Send us an email</CardTitle>
        </CardHeader>
        <CardContent className="grid gap-4">
          <div className="grid gap-2">
            <Label htmlFor="email">Your Email</Label>
            <Input id="email" type="email" placeholder="you@example.com" />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="message">Message</Label>
            <Textarea id="message" placeholder="How can we help?" rows={5} />
          </div>
          <Button className="w-fit quirky-btn">Send</Button>
        </CardContent>
      </Card>
    </div>
  );
}
